import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import R from 'ramda';

const { array, bool, node, object } = PropTypes;

const PotentialPartners = ({ classes, data }) => {
  const countries = data.countries.length === 1
    ? data.countries[0]
    : `${R.dropLast(1, data.countries).join(', ')} and ${R.last(data.countries)}`;
  return (<div style={{ padding: '8px' }}>
    <div style={{ textAlign: 'center' }}>You have sent rates to</div>
    <div style={{ textAlign: 'center', margin: '8px 0' }}>
      <span style={{ fontSize: '18px' }}>{data.sentCount || 0}</span>&nbsp; out of &nbsp;<Link to="/partner-finder/results" style={{ fontSize: '18px' }}>{data.totalCount || 0}</Link>
    </div>
    <div style={{ textAlign: 'center' }}>Buyers that send travelers to {countries}.</div>
  </div>);
};

PotentialPartners.propTypes = {
  data: object,
  style: object,
};

export default PotentialPartners;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/charts/PotentialPartners.jsx